import { makeAutoObservable, runInAction } from 'mobx'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { openApi } from './request'

dayjs.extend(utc)
dayjs.extend(timezone)

// Время проекта: даты, которые админка показывает и принимает, считаются по часовому поясу проекта (kssettings.timezone),
// а не браузера и не UTC. Пояс не выбран — UTC, как у остальных расчётов проекта на бэкенде.
class ProjectTime {
    timezone = ''

    constructor() {
        makeAutoObservable(this)
    }

    load() {
        if (this.timezone) return

        openApi('get', 'settings')
            .then(result => runInAction(() => {
                this.timezone = result.data.timezone || 'UTC'
            }))
            .catch(error => console.log(error))
    }

    get zone(): string {
        return this.timezone || 'UTC'
    }

    // Время проекта как «настенное» время браузера (те же год, месяц, день, час и минута): календари и форматирование
    // работают со временем браузера, поэтому им отдаём именно такое представление
    wall(unix: number): dayjs.Dayjs {
        const time = dayjs.unix(unix).tz(this.zone)

        return dayjs(new Date(time.year(), time.month(), time.date(), time.hour(), time.minute()))
    }

    // То же в миллисекундах «как будто UTC»: так печатает moment_custom (moment.utc)
    wallMs(unix: number): number {
        return (unix + dayjs.unix(unix).tz(this.zone).utcOffset() * 60) * 1000
    }

    // Начало суток по времени проекта для даты, выбранной в календаре (unix)
    startOfDay(date: dayjs.Dayjs): number {
        return dayjs.tz(date.format('YYYY-MM-DD'), this.zone).unix()
    }
}

export default new ProjectTime()
